export default "__VITE_ASSET__CHQqiFzQ__"